export function getFeedbackLink() {
  return 'https://teuteuf.notion.site/17eeff4e9f3880e2a6aeef075e74939b?pvs=105';
}
